import GateController from '../../assets/js/controllers/gate';
import ModalController from '../../assets/js/controllers/modal';

// static constants
import GateEvent from '../../assets/js/constants/gate-event';

// helpers
import { multiAddEventListener, multiRemoveEventListener } from '../../assets/js/helpers';

export default class ModalGateWebinarEbook {

	static selector = 'modal-gate-webinar-ebook';

	// class variables

	config = {};

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctasClose: container.querySelectorAll('[data-modal-cta-close]')
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add / remove event listeners

	#addEventListeners = () => {
		document.body.addEventListener('hsvalidatedsubmit', this.#onFormSubmit);
		multiAddEventListener(this.el.ctasClose, 'click', this.#onCtaCloseClick);
	}

	#removeEventListeners = () => {
		document.body.addEventListener('hsvalidatedsubmit', this.#onFormSubmit);
		multiRemoveEventListener(this.el.ctasClose, 'click', this.#onCtaCloseClick);
	}

	// listener methods

	#onFormSubmit = (e) => {
		// Firefox/Safari to not have e.path - they use e.composedPath
		const eventPath = e.path || (e.composedPath && e.composedPath());
		for (let i = 0; i < eventPath.length; i++) {
			const $pathItem = eventPath[i];
			if ($pathItem instanceof Element && this.el.container.contains($pathItem)) {
				document.body.dispatchEvent(new CustomEvent(GateEvent.UNLOCK));
				GateController.setGateStatus($pathItem.closest('.modal').getAttribute('id'), true);
				ModalController.close();
				break;
			}
		}
	}

	#onCtaCloseClick = () => {
		document.body.dispatchEvent(new CustomEvent(GateEvent.CANCEL));
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
